import { useMutation } from "@tanstack/react-query";
import TabletMpProvider from "@/core/data-provider/data-mp/tablet/tablet-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";

export function useLaunchMarketplaceAppMutation() {
  return useMutation({
    mutationFn: async () => {
      try {
        const response = await TabletMpProvider.launchMarketplaceApp();

        if (response instanceof RpcMpProviderFailedResponse) {
          console.error("Failed to launch marketplace app:", response);
          return false;
        }

        console.log("Marketplace app launched successfully:", { response });
        return true;
      } catch (error) {
        console.error("Failed to launch marketplace app:", error);
        return false;
      }
    },
  });
}
